import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isOpen: boolean
}

export const Header = styled(ButtonPlain)<Props>`
	display: flex;
	padding: 12px 16px;
	column-gap: ${helpers.spacing.medium};
	align-items: center;
	transition: background-color 150ms ${helpers.animation.default};
	width: 100%;
	background-color: ${({ theme }) => transparentize(0.91, theme.color.action)};

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => transparentize(0.85, theme.color.actionHover)};
	}
`
